import type { AssessmentData } from '@physitrack/championhealth-types';

const HEIGHT_SUB_FIELDS = ['height_ft', 'height_in', 'height_cm'] as const;
const WEIGHT_SUB_FIELDS = ['weight_st', 'weight_lb', 'weight_kg'] as const;
const SKIPPED_OR_UNSURE = new Set(['skipped', 'unsure']);

/**
 * Prepares the web UI's `assessmentValues` for the API.
 *
 * Internal state already matches the `AssessmentData` shape from
 * `@physitrack/championhealth-types` (components emit values in the
 * correct format), so the only transforms needed are:
 * - stamping the version
 * - stripping measurement sub-fields when the parent is skipped/unsure
 *   (the numeric values may still linger in state from a previous entry)
 */
export const transformAssessmentForApi = (
  values: Record<string, unknown>
): Partial<AssessmentData> => {
  const result: Record<string, unknown> = { ...values, assessmentVersion: '2-web' };

  if (SKIPPED_OR_UNSURE.has(result.height as string)) {
    HEIGHT_SUB_FIELDS.forEach((field) => delete result[field]);
  }

  if (SKIPPED_OR_UNSURE.has(result.weight as string)) {
    WEIGHT_SUB_FIELDS.forEach((field) => delete result[field]);
  }

  return result as Partial<AssessmentData>;
};
